import React from 'react';
import { Container, Typography, Box, Grid, Card, CardContent, Avatar, CardMedia } from '@mui/material';

const Committee = () => {
  const committeeMembers = {
    organizingCommittee: [
      {
        name: 'Dr. Pamela Jeyaraj',
        designation: 'Organizing Chairperson and Secretary',
        image: require('../assets/committee/pam.jpeg'),
      },
      {
        name: 'Dr. Jaineet Sachdeva',
        designation: 'Organizing Co-Chairperson',
        image: require('../assets/committee/janit.jpeg'),
      },
      {
        name: 'Dr. Mary Joan',
        designation: 'Joint Organizing Secretary',
        image: require('../assets/committee/mary.jpeg'),
      },
      {
        name: 'Dr. Abraham P Abraham',
        designation: 'Treasurer',
        image: require('../assets/committee/abraham.jpeg'),
      },
      {
        name: 'Dr. Joel Abraham',
        designation: 'Joint Organizing Secretary',
        image: require('../assets/committee/joel.jpeg'),
      },
      // {
      //   name: 'Dr. Elizabeth Jose MD',
      //   designation: 'Joint Organizing Secretary',
      //   image: '/assets/committee/member3.jpg',
      // },
    ],
    northZoneAROI: [
      {
        name: 'Dr Deepak Abrol',
        designation: 'President',
        image: require('../assets/committee/deepak.jpeg'), // Temporary image
      },
      {
        name: 'Dr Pardeep Garg',
        designation: 'Secretary',
        image: require('../assets/committee/pradeep.jpeg'), // Temporary image
      },
      {
        name: 'Dr Neeraj Jain',
        designation: 'Past President',
        image: require('../assets/committee/neeraj.jpeg'), // Temporary image
      },
    ],
    nationalExecutiveAROI: [
      {
        name: 'Dr Manoj Gupta',
        designation: 'Chair AROI',
        image: require('../assets/committee/manoj.jpeg'), // Temporary image
      },
      {
        name: 'Dr S N Senapati',
        designation: 'President AROI',
        image: require('../assets/committee/senapati.jpeg'), // Temporary image
      },
      {
        name: 'Dr C. S. Madhu',
        designation: 'President Elect AROI',
        image: require('../assets/committee/madhu.jpeg'), // Temporary image
      },
      {
        name: 'Dr V. Srinivasan',
        designation: 'Secretary AROI',
        image: require('../assets/committee/sri.jpeg'), // Temporary image
      },
    ],
    scientificCommittee: [
      {
        name: 'Dr. Bhawana Rai',
        designation: 'Chairperson',
        image: require('../assets/committee/bhavna.jpeg'),
      },
      {
        name: 'Dr. Harpreet Singh',
    
        image: require('../assets/committee/harpreet.jpeg'),
      },
      {
        name: 'Dr. Preety Negi',
      
        image: require('../assets/committee/preety.jpeg'),
      },
      {
        name: 'Dr. Raja Paramjeet Singh',

        image: require('../assets/committee/raja.jpeg'),
      },
      {
        name: 'Dr. Parneet Singh',
      
        image: require('../assets/committee/parneet.jpeg'),
      },
      {
        name: 'Dr. Vivek Shaw',
     
        image: require('../assets/committee/vivek.jpeg'),
      },
      {
        name: 'Dr. Deepak Jain',

        image: require('../assets/committee/deepakj.jpeg'),
      },
      {
        name: 'Dr. Raman Arora',

        image: require('../assets/committee/raman2.jpeg'),
      },
    ],
  };

  const chiefPatronsAndPatrons = [
    {
      name: 'Dr William Bhatti',
      designation: 'Chief Patron',
      image: require('../assets/committee/bhatti.jpeg'),
    },
    {
      name: 'Dr Jeyaraj D. Pandian',
      designation: 'Chief Patron',
      image: require('../assets/committee/jeyaraj.jpeg'),
    },
    {
      name: 'Dr M. K. Mahajan',
      designation: 'Patron',
      image: require('../assets/committee/mahajan.jpeg'),
    },
    {
      name: 'Dr Rajesh Vashistha',
      designation: 'Patron',
      image: require('../assets/committee/rajesh.jpeg'),
    },
  ];

  return (
    <Container maxWidth="lg" sx={{ py: 4 }}>
      <Typography variant="h4" component="h1" gutterBottom align="center" sx={{ mb: 2 }}>
        Conference Committee
      </Typography>
      <Typography variant="subtitle1" paragraph align="center" sx={{ mb: 4 }}>
        Meet the organizing committee members who are working to make this conference a success
      </Typography>

      {/* Chief Patrons and Patrons Section */}
      <Box sx={{ mb: 6 }}>
        <Grid container spacing={3} justifyContent="center">
          {chiefPatronsAndPatrons.map((member, index) => (
            <Grid item xs={12} sm={6} md={3} key={index}>
              <Card sx={{ height: '100%', display: 'flex', flexDirection: 'column' }}>
                <CardMedia
                  component="img"
                  height="250"
                  image={member.image}
                  alt={member.name}
                  sx={{
                    objectFit: 'contain',
                    padding: '10px',
                    backgroundColor: '#f8f9fa'
                  }}
                />
                <CardContent sx={{ flexGrow: 1 }}>
                  <Typography gutterBottom variant="h6" component="div">
                    {member.name}
                  </Typography>
                  <Typography variant="body2" color="text.secondary">
                    {member.designation}
                  </Typography>
                </CardContent>
              </Card>
            </Grid>
          ))}
        </Grid>
      </Box>

      {/* Organizing Committee Section */}
      <Typography variant="h5" component="h2" gutterBottom align="center" sx={{ mb: 4 }}>
        Organizing Committee
      </Typography>
      <Grid container spacing={3} justifyContent="center">
        {committeeMembers.organizingCommittee.map((member, index) => (
          <Grid item xs={12} sm={6} md={4} key={index}>
            <Card elevation={0} sx={{ height: '100%', backgroundColor: '#f8f9fa' }}>
              <CardContent sx={{ textAlign: 'center' }}>
                <Avatar
                  src={member.image}
                  alt={member.name}
                  sx={{ width: 120, height: 120, margin: '0 auto 16px' }}
                />
                <Typography variant="h6" component="h3" gutterBottom>
                  {member.name}
                </Typography>
                <Typography color="primary" gutterBottom>
                  {member.designation}
                </Typography>
              </CardContent>
            </Card>
          </Grid>
        ))}
      </Grid>

      {/* North Zone AROI Section */}
      <Typography variant="h5" component="h2" gutterBottom align="center" sx={{ mt: 6, mb: 4 }}>
        North Zone AROI
      </Typography>
      <Grid container spacing={3} justifyContent="center">
        {committeeMembers.northZoneAROI.map((member, index) => (
          <Grid item xs={12} sm={6} md={4} key={index}>
            <Card elevation={0} sx={{ height: '100%', backgroundColor: '#f8f9fa' }}>
              <CardContent sx={{ textAlign: 'center' }}>
                <Avatar
                  src={member.image}
                  alt={member.name}
                  sx={{ width: 120, height: 120, margin: '0 auto 16px' }}
                />
                <Typography variant="h6" component="h3" gutterBottom>
                  {member.name}
                </Typography>
                <Typography color="primary" gutterBottom>
                  {member.designation}
                </Typography>
              </CardContent>
            </Card>
          </Grid>
        ))}
      </Grid>

      {/* National Executive AROI Section */}
      <Typography variant="h5" component="h2" gutterBottom align="center" sx={{ mt: 6, mb: 4 }}>
        National Executive AROI
      </Typography>
      <Grid container spacing={3} justifyContent="center">
        {committeeMembers.nationalExecutiveAROI.map((member, index) => (
          <Grid item xs={12} sm={6} md={3} key={index}>
            <Card elevation={0} sx={{ height: '100%', backgroundColor: '#f8f9fa' }}>
              <CardContent sx={{ textAlign: 'center' }}>
                <Avatar
                  src={member.image}
                  alt={member.name}
                  sx={{ width: 120, height: 120, margin: '0 auto 16px' }}
                />
                <Typography variant="h6" component="h3" gutterBottom>
                  {member.name}
                </Typography>
                <Typography color="primary" gutterBottom>
                  {member.designation}
                </Typography>
              </CardContent>
            </Card>
          </Grid>
        ))}
      </Grid>

      {/* Scientific Committee Section */}
      <Typography variant="h5" component="h2" gutterBottom align="center" sx={{ mt: 6, mb: 4 }}>
        Scientific Committee
      </Typography>
      <Grid container spacing={3} justifyContent="center">
        {committeeMembers.scientificCommittee.map((member, index) => (
          <Grid item xs={12} sm={6} md={4} key={index}>
            <Card elevation={0} sx={{ height: '100%', backgroundColor: '#f8f9fa' }}>
              <CardContent sx={{ textAlign: 'center' }}>
                <Avatar
                  src={member.image}
                  alt={member.name}
                  sx={{ width: 120, height: 120, margin: '0 auto 16px' }}
                />
                <Typography variant="h6" component="h3" gutterBottom>
                  {member.name}
                </Typography>
                <Typography color="primary" gutterBottom>
                  {member.designation}
                </Typography>
              </CardContent>
            </Card>
          </Grid>
        ))}
      </Grid>
    </Container>
  );
};

export default Committee; 
